import { useTranslation } from 'react-i18next';

import { Button } from '../../../../components/Button';
import { StyledModalFooter } from '../../../../components/Modal/styles';
import { Tooltip } from '../../../../components/Tooltip';
import useVisibilityTransition from '../../../../hooks/useVisibilityTransition';
import { PreferencesHeader } from '../PreferencesHeader';

import { StyledPreferenceInnerModal, StyledPreferenceContent } from './styles';

type PreferencesInnerModalProps = {
  isOpen: boolean;
  isNew?: boolean;
  onClose: () => void;
  onReturn: () => void;
  onSave: () => void;
  title: string;
  subtitle: string;
  isSaveDisabled: boolean;
  isLoading?: boolean;
  tooltipContent?: string | null;
  children?: React.ReactNode;
};

export const PreferencesInnerModal = ({
  isOpen,
  isNew,
  onClose,
  onReturn,
  onSave,
  title,
  subtitle,
  isSaveDisabled,
  isLoading,
  tooltipContent,
  children,
}: PreferencesInnerModalProps) => {
  const { t } = useTranslation();

  const isTransitioning = useVisibilityTransition(isOpen);

  return (
    <StyledPreferenceInnerModal isOpen={isOpen} isTransitioning={isTransitioning}>
      <PreferencesHeader title={title} subtitle={subtitle} onReturn={onReturn} isNew={isNew} />
      <StyledPreferenceContent>{children}</StyledPreferenceContent>
      <StyledModalFooter data-automation="ModalFooter">
        <Button onClick={onClose} variant="flat">
          {t('common.cancel')}
        </Button>

        <Tooltip enabled={isSaveDisabled ? !!tooltipContent : null} content={tooltipContent} minWidth={100}>
          <Button onClick={onSave} variant="primary" disabled={isSaveDisabled} isLoading={isLoading}>
            {t('common.apply')}
          </Button>
        </Tooltip>
      </StyledModalFooter>
    </StyledPreferenceInnerModal>
  );
};
